"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ButtonFooter = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 監査結果参照録画面フッタのボタン
 */
const StyledFooter = (0, _styles.styled)('footer')({
  width: '100%',
  textAlign: 'right'
});
const ButtonFooter = props => {
  const {
    returnBtn,
    closeBtn,
    isNewWindow
  } = props;
  return /*#__PURE__*/_react.default.createElement(StyledFooter, null, isNewWindow ? closeBtn() : returnBtn(), "\u3000");
};
exports.ButtonFooter = ButtonFooter;
var _default = exports.default = ButtonFooter;